import { render, staticRenderFns } from "./ObjectsCustomGroupsList.vue?vue&type=template&id=f3d17a8e&scoped=true&"
import script from "./ObjectsCustomGroupsList.vue?vue&type=script&lang=js&"
export * from "./ObjectsCustomGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsCustomGroupsList.vue?vue&type=style&index=0&id=f3d17a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d17a8e",
  null
  
)

export default component.exports